__turbopack_context__.v({
  "blok-big-title": "styles-module__6xFObG__blok-big-title",
  "blok-subtitle": "styles-module__6xFObG__blok-subtitle",
  "blok-title": "styles-module__6xFObG__blok-title",
  "image": "styles-module__6xFObG__image",
  "zoom": "styles-module__6xFObG__zoom",
  "zoomButton": "styles-module__6xFObG__zoomButton",
  "zoomImageContainer": "styles-module__6xFObG__zoomImageContainer",
});
